import '@/plugins/observability'

import { ComponentLibrary } from '@alice-health/wonderland-vue'
import { setupCalendar } from 'v-calendar'
import { createApp } from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'

import App from '@/App.vue'
import router from '@/router'

import { outsideClicked } from './directives/outside-click.directive'
import { configureSegment } from './plugins/segment'
import store from './store'

configureSegment()

const initiateVue = () => {
  const app = createApp(App)
  app.use(router)
  app.use(store)
  app.use(ComponentLibrary)
  app.use(VueObserveVisibility)
  app.use(setupCalendar, {
    componentPrefix: 'vc'
  })
  app.directive('outside-click', outsideClicked)
  app.mount('#app')
}

initiateVue()
